import { ReactElement, ReactNode } from "react";

export default function ImpactElement(props: { title: string, unit: string, children: ReactElement<any, any>[], icon: ReactNode }) {
    return (
        <div className="flex flex-col gap-2">
            <div className="flex justify-between items-center mb-2">
                <div className="flex items-center gap-3">
                    {props.icon}
                    <h5 className="text-base md:text-xl xshort:text-base font-semibold">
                        {props.title}
                    </h5>
                </div>

                <p className="italic md:text-sm text-xs xshort:text-xs text-darkLight dark:text-whiteLight">
                    {props.unit}
                </p>
            </div>
            {props.children.map((child) => {
                return child;
            })}
        </div>
    );
}